import React, { useState, useEffect } from 'react';
import './LandingPageV2.css';

const API_URL = process.env.REACT_APP_API_URL || 'https://b.supchats.com';

function ContactPage() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [extraContact, setExtraContact] = useState('');
  const [subject, setSubject] = useState('');
  const [captchaImage, setCaptchaImage] = useState(null);
  const [captchaToken, setCaptchaToken] = useState('');
  const [captchaAnswer, setCaptchaAnswer] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const refreshCaptcha = async () => {
    try {
      const res = await fetch(`${API_URL}/captcha/new`);
      const data = await res.json();
      setCaptchaImage(data.image);
      setCaptchaToken(data.token);
      setCaptchaAnswer('');
    } catch (e) {
      // ignore
    }
  };

  useEffect(() => {
    refreshCaptcha();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');

    if (!name.trim() || !email.trim() || !subject.trim()) {
      setMessage('Please fill in your name, email and message.');
      return;
    }

    if (!captchaAnswer.trim()) {
      setMessage('Please enter the text from the image (captcha).');
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/contact-requests`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name,
          email,
          extra_contact: extraContact,
          subject,
          captcha_token: captchaToken,
          captcha_answer: captchaAnswer,
        }),
      });

      const data = await res.json();
      if (!res.ok || !data.ok) {
        if (data.detail && data.detail === 'Captcha validation failed') {
          setMessage('Captcha validation failed. Please try again.');
          await refreshCaptcha();
        } else {
          setMessage(data.detail || 'Failed to submit your request.');
        }
        return;
      }

      setMessage("Your message has been sent. We'll get back to you as soon as possible.");
      setName('');
      setEmail('');
      setExtraContact('');
      setSubject('');
      setCaptchaAnswer('');
      await refreshCaptcha();
    } catch (e) {
      setMessage('Network error while submitting your request.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="landing-v2">
      <header className="landing-v2-header">
        <div className="header-container">
          <div className="logo">
            <img
              src={process.env.PUBLIC_URL + '/logo512.png'}
              alt="Supchats logo"
              className="logo-img"
            />
            <span className="logo-text">Supchats</span>
          </div>
        </div>
      </header>

      <div className="public-page contact-page">
        <div className="public-hero">
          <h1>Get in touch with Supchats</h1>
          <p>Send us a message and we will get back to you as soon as possible.</p>
        </div>

        <div className="public-section">
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <label>Name *</label>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="form-input"
                placeholder="Your name"
              />
            </div>

            <div className="form-row">
              <label>Email *</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="form-input"
                placeholder="you@example.com"
              />
            </div>

            <div className="form-row">
              <label>Additional contact</label>
              <input
                type="text"
                value={extraContact}
                onChange={(e) => setExtraContact(e.target.value)}
                className="form-input"
                placeholder="Telegram, WhatsApp, phone, etc."
              />
            </div>

            <div className="form-row">
              <label>Message *</label>
              <textarea
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                className="form-textarea"
                placeholder="Describe your question or issue"
                rows={4}
              />
            </div>

            <div className="form-row">
              <label>Captcha *</label>
              <div className="captcha-row">
                {captchaImage ? (
                  <img src={captchaImage} alt="captcha" className="captcha-image" />
                ) : (
                  <div className="captcha-placeholder">Loading captcha...</div>
                )}
                <button
                  type="button"
                  onClick={refreshCaptcha}
                  className="captcha-refresh"
                  title="Refresh captcha"
                >
                  ↻
                </button>
              </div>
              <input
                type="text"
                value={captchaAnswer}
                onChange={(e) => setCaptchaAnswer(e.target.value)}
                className="form-input"
                placeholder="Enter the text from the image"
              />
            </div>

            {message && (
              <div className="contact-message">
                {message}
              </div>
            )}

            <button type="submit" className="submit-button" disabled={loading}>
              {loading ? 'Sending...' : 'Send message'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ContactPage;

